import { render, staticRenderFns } from "./BoContacMessage.vue?vue&type=template&id=0917197c&"
import script from "./BoContacMessage.vue?vue&type=script&lang=js&"
export * from "./BoContacMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports